import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    auxiliarIndex: 0,
    connectionPointId: 0,
    staffMembers: [],
    staffIds: [],
    lastIndex: 0,
    newStaffs: [],
    editForm: false,
    newStaffForms: [],
    staffMembersLocal: []
}

export const staffSlice = createSlice({
    name: 'linkStaff',
    initialState,
    reducers: {
        setAuxiliarIndex: (state, action) => {
            return {
                ...state,
                auxiliarIndex: state.auxiliarIndex + 1
            }
        },
        setConnectionPointId: (state, action) => {
            state.connectionPointId = action.payload
        },
        setStaffMembers: (state, action) => {
            if (action.payload.actionArray == 'add') {
                if (state.staffMembers.length > 0) {
                    state.staffMembers = [...state.staffMembers, action.payload.staffMember]
                } else {
                    state.staffMembers = action.payload.staffMembers
                }
            } else if (action.payload.actionArray == 'update') {
                state.staffMembers = action.payload.staffMembers
            }
        },
        updateStaffMembers: (state, action) => {
            state.staffMembers = action.payload
        },
        setStaffIds: (state, action) => {
            if (action.payload.actionArray == 'add') {
                state.staffIds = [...state.staffIds, action.payload.id]
            } else if (action.payload.actionArray == 'remove') {
                state.staffIds = state.staffIds.filter((_, index) => index !== action.payload.index)
            } else if (action.payload.actionArray == 'update') {
                state.staffIds = action.payload.staffIds
            }
        },
        setLastIndex: (state, action) => {
            const lastStaffMember = state.staffMembers[state.staffMembers.length - 1]
            const lastIndex = state.staffMembers.indexOf(lastStaffMember)
            state.lastIndex = lastIndex
        },
        deleteStaffMember: (state, action) => {
            state.staffMembers = state.staffMembers.filter((_, index) => index !== action.payload)
        },
        addNewStaffStorage: (state, action) => {
            state.newStaffs = [...state.newStaffs, action.payload]
        },
        removeNewStaffStorage: (state, action) => {
            state.newStaffs = state.newStaffs.filter((_, index) => index !== action.payload)
        },
        setNewStaffs: (state, action) => {
            state.newStaffs = action.payload
        },
        setEditForm: (state, action) => {
            state.editForm = action.payload
        },
        setNewStaffForms: (state, action) => {
            state.newStaffForms = action.payload
        },
        addNewStaffForm: (state, action) => {
            state.newStaffForms = [...state.newStaffForms, action.payload]
        },
        setStaffMemberLocal: (state, action) => {
            state.staffMembersLocal = [...state.staffMembersLocal, action.payload]
        },
        deleteStaffMemberLocal: (state, action) => {
            state.staffMembersLocal = state.staffMembersLocal.filter((_, index) => index !== action.payload)
        },
        resetStateStaff: () => initialState
    }
})

export const {
    setAuxiliarIndex,
    setConnectionPointId,
    setStaffMembers,
    deleteStaffMember,
    setStaffIds,
    setLastIndex,
    addNewStaffStorage,
    removeNewStaffStorage,
    setNewStaffs,
    setEditForm,
    setNewStaffForms,
    setStaffMemberLocal,
    deleteStaffMemberLocal,
    addNewStaffForm,
    resetStateStaff,
    updateStaffMembers
} = staffSlice.actions
export default staffSlice.reducer
